import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function RelatedProductsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const products = [{
    name: '8:8 Pomegranate',
    image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/e4ab495b-c6f7-4193-b677-9b7d9923de4f.png?v=1763794573',
    rating: 4.9,
    reviews: 2847,
    description: 'Heart Health',
    link: 'https://pomegranates.faithandfig.com'
  }, {
    name: '2:11 Frankincense',
    image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/843ed722-fcab-49c4-9afc-c384ca51f27b.png?v=1763794574',
    rating: 4.8,
    reviews: 3201,
    description: 'Joint Comfort',
    link: 'https://frankincense.faithandfig.com'
  }, {
    name: '8:11 Olive Leaf',
    image: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/72532349-ff6e-47c4-9330-04556b782119.png?v=1763794573',
    rating: 4.8,
    reviews: 1956,
    description: 'Immune Defense',
    link: 'https://oliveleaf.faithandfig.com'
  }];
  const visibleProducts = 3;
  const maxIndex = Math.max(0, products.length - visibleProducts);
  const nextProducts = () => {
    setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  };
  const prevProducts = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };
  return <section className="w-full bg-[#f5f1ed] py-16 lg:py-20" data-id="element-434">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-435">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-436">
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-[#2d4a3a] mb-3" data-id="element-437">
            We Think You'll Love These Too
          </h2>
          <p className="text-gray-600 text-base" data-id="element-438">
            Christians often pair 4:14 Saffron with these for even deeper
            support
          </p>
        </div>

        {/* Products Carousel */}
        <div className="relative" data-id="element-439">
          <div className="overflow-hidden" data-id="element-440">
            <div className="flex transition-transform duration-500 ease-out gap-6" style={{
            transform: `translateX(-${currentIndex * (100 / visibleProducts)}%)`
          }} data-id="element-441">
              {products.map((product, index) => <a key={index} href={product.link} className="flex-shrink-0 w-full md:w-1/3 bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all group block cursor-pointer" style={{
              minWidth: `calc(${100 / visibleProducts}% - 1rem)`
            }} data-id="element-442">
                  {/* Product Image */}
                  <div className="relative aspect-square bg-[#f5f1ed] overflow-hidden" data-id="element-443">
                    <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-444" />
                    <div className="absolute top-3 right-3 bg-[#496f58] text-white text-xs font-bold px-3 py-1.5 rounded-full animate-pulse" data-id="element-445">
                      NEW
                    </div>
                  </div>

                  {/* Product Info */}
                  <div className="p-5" data-id="element-446">
                    <h3 className="font-serif text-xl font-bold text-[#2d4a3a] mb-1" data-id="element-447">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-3" data-id="element-448">
                      {product.description}
                    </p>

                    {/* Rating */}
                    <div className="flex items-center gap-2 mb-3" data-id="element-449">
                      <div className="flex items-center gap-0.5" data-id="element-450">
                        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-[#d4af37] text-[#d4af37]" data-id="element-451" />)}
                      </div>
                      <span className="text-xs text-gray-600" data-id="element-452">
                        {product.rating} ({product.reviews})
                      </span>
                    </div>
                  </div>
                </a>)}
            </div>
          </div>

          {/* Carousel Controls */}
          {products.length > visibleProducts && <>
              <button onClick={prevProducts} disabled={currentIndex === 0} className={`absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 rounded-full bg-white shadow-xl flex items-center justify-center transition-all ${currentIndex === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#496f58] hover:text-white'}`} aria-label="Previous products" data-id="element-453">
                <ChevronLeftIcon className="w-6 h-6" data-id="element-454" />
              </button>

              <button onClick={nextProducts} disabled={currentIndex === maxIndex} className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 rounded-full bg-white shadow-xl flex items-center justify-center transition-all ${currentIndex === maxIndex ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#496f58] hover:text-white'}`} aria-label="Next products" data-id="element-455">
                <ChevronRightIcon className="w-6 h-6" data-id="element-456" />
              </button>
            </>}

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8" data-id="element-457">
            {Array.from({
            length: maxIndex + 1
          }).map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 rounded-full transition-all ${currentIndex === index ? 'bg-[#496f58] w-8' : 'bg-[#496f58]/30 w-2'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-458" />)}
          </div>
        </div>
      </div>
    </section>;
}